import { type ReactNode } from 'react';

import * as Styled from './ListNative.styled';

type ListType = 'ul' | 'ol';

type Props = {
  /**
   * If only one child is passed, we add it to an array and map it to a list item.
   * Otherwise, each child is mapped as a list item.
   */
  children: ReactNode | Array<ReactNode>;
  name: string;
} & Partial<Styled.ListSpacing> &
  Partial<Styled.ListItemProps>;

const ListNative = (props: Props) => {
  const {
    children,
    listType = 'ul',
    gap,
    name,
    markerColour = 'GREY_DARK',
    markerSize = 'M14',
    markerFontWeight = 'regular',
  } = props;

  const items = Array.isArray(children) ? children : [children];

  return (
    <Styled.ListContainer
      as={listType}
      gap={gap}
      markerSize={markerSize}
      markerColour={markerColour}
    >
      {items.map((item, index) => {
        if (item) {
          return (
            <Styled.ListItem
              key={`${name}-list-item-no.${index + 1}`}
              listType={listType}
              markerFontWeight={markerFontWeight}
            >
              {item}
            </Styled.ListItem>
          );
        }
      })}
    </Styled.ListContainer>
  );
};

export { ListNative, type Props, type ListType };
